import { PlusOutlined } from '@ant-design/icons';
import { Button, message, Row, Upload } from 'antd';
import Title from 'antd/lib/typography/Title';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/selectors';
import { SignatureModal } from '../../../pages/data/organization/tracked-items/components/SignatureModal';

const UserSignatureUpload = () => {
  const user = useSelector(getUser);
  const [signatureUrl, setSignatureUrl] = useState(
    user?.Profile.SignatureURL ? user?.Profile.SignatureURL : null,
  );
  const [isSignatureModalVisible, setIsSignatureModalVisible] = useState(false);

  return (
    <div style={{ marginBottom: '50px' }}>
      {signatureUrl && (
        <img src={signatureUrl} alt="signature" style={{ width: '300px', marginBottom: '20px' }} />
      )}
        <>
          <Title level={5}>Upload Signature </Title>
          <div>
            <Row>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsSignatureModalVisible(true)}>Add Signature</Button>
            </Row>
            <SignatureModal
              isVisible={isSignatureModalVisible}
              setIsVisible={setIsSignatureModalVisible}
              userID={user?.id}
              setSignatureUrl={setSignatureUrl}
            />
          </div>
        </>
    </div>
  );
};

export default UserSignatureUpload;
